export default "__VITE_ASSET__BISmRTtK__"